import GreenHomeSelectFloor from "../assest/GreenHome/images/GreenHomeSelectFloor.jpeg";
import FloorRenderHigh from "../assest/GreenHome/images/FloorRenderHigh.jpg";
import NikeaHerroImg from "../assest/Nikea/images/NikeaHerroImg.jpeg";
import nikeaListImg from "../assest/Nikea/images/image6.jpeg";
import { NikeaFloorRenderImgPaths } from "../assest/Nikea/floorRenders/paths";
import { greenHomeOutterRenderPaths } from "../assest/imgPaths";

export const greenHomeApartmentsRoomsSizes = [
  {
    apartmentNumber: 1,
    rooms: [
      { label: "ჰოლი", size: 14 },
      { label: "საერთო ოთახი", size: 25.22 },
      { label: "საძინებელი 1", size: 13.5 },
      { label: "საძინებელი 2", size: 13 },
      { label: "სველი წერტილი", size: 7 },
      { label: "ტერასა", size: 8 },
    ],
  },
  {
    apartmentNumber: 2,
    rooms: [
      { label: "საერთო ოთახი", size: 49.41 },
      { label: "საძინებელი 1", size: 14 },
      { label: "საძინებელი 2", size: 17 },
      { label: "საძინებელი 3", size: 17 },
      { label: "სველი წერტილი", size: 7.5 },
      { label: "ტერასა 1", size: 10 },
      { label: "ტერასა 2", size: 10 },
    ],
  },
  {
    apartmentNumber: 3,
    rooms: [
      { label: "საერთო ოთახი", size: 50.95 },
      { label: "საძინებელი 1", size: 20 },
      { label: "საძინებელი 2", size: 28 },
      { label: "სველი წერტილი", size: 8 },
      { label: "ტერასა", size: 8 },
    ],
  },
  {
    apartmentNumber: 4,
    rooms: [
      { label: "საერთო ოთახი", size: 60.21 },
      { label: "საძინებელი 1", size: 15 },
      { label: "საძინებელი 2", size: 16.9 },
      { label: "სველი წერტილი 1", size: 7 },
      { label: "სველი წერტილი 1", size: 4 },
      { label: "ტერასა 1", size: 8 },
      { label: "ტერასა 2", size: 8 },
    ],
  },
  {
    apartmentNumber: 5,
    rooms: [
      { label: "საერთო ოთახი", size: 37.74 },
      { label: "საძინებელი 1", size: 17 },
      { label: "საძინებელი 2", size: 9 },
      { label: "საძინებელი 3", size: 13.5 },
      { label: "სველი წერტილი", size: 7 },
      { label: "ტერასა 1", size: 4.5 },
      { label: "ტერასა 2", size: 4.2 },
    ],
  },
  {
    apartmentNumber: 6,
    rooms: [
      { label: "საერთო ოთახი", size: 25.46 },
      { label: "საძინებელი", size: 16.5 },
      { label: "სველი წერტილი", size: 4 },
      { label: "ტერასა", size: 4.8 },
    ],
  },
  {
    apartmentNumber: 7,
    rooms: [
      { label: "საერთო ოთახი", size: 36.89 },
      { label: "საძინებელი", size: 13.5 },
      { label: "სველი წერტილი", size: 8 },
      { label: "ტერასა", size: 4.4 },
    ],
  },
  {
    apartmentNumber: 8,
    rooms: [
      { label: "საერთო ოთახი", size: 24.93 },
      { label: "საძინებელი", size: 14 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 4.51 },
    ],
  },
  {
    apartmentNumber: 9,
    rooms: [
      { label: "საერთო ოთახი", size: 24.45 },
      { label: "საძინებელი", size: 14 },
      { label: "სველი წერტილი", size: 6.5 },
      { label: "ტერასა", size: 4.2 },
    ],
  },
  {
    apartmentNumber: 10,
    rooms: [
      { label: "საერთო ოთახი", size: 40.78 },
      { label: "საძინებელი 1", size: 14 },
      { label: "საძინებელი 2", size: 15 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა 1", size: 4.2 },
      { label: "ტერასა 2", size: 7 },
    ],
  },
  {
    apartmentNumber: 11,
    rooms: [
      { label: "საერთო ოთახი", size: 25.25 },
      { label: "საძინებელი", size: 13.7 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 4.2 },
    ],
  },
  {
    apartmentNumber: 12,
    rooms: [
      { label: "საერთო ოთახი", size: 36.3 },
      { label: "საძინებელი", size: 13.2 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 7 },
    ],
  },
  {
    apartmentNumber: 13,
    rooms: [
      { label: "საერთო ოთახი", size: 29.05 },
      { label: "საძინებელი 1", size: 11.9 },
      { label: "საძინებელი 2", size: 12.4 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა 1", size: 7 },
      { label: "ტერასა 2", size: 4.3 },
    ],
  },
  {
    apartmentNumber: 14,
    rooms: [
      { label: "საერთო ოთახი", size: 25.79 },
      { label: "საძინებელი", size: 12.5 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 4.2 },
    ],
  },
  {
    apartmentNumber: 15,
    rooms: [
      { label: "საერთო ოთახი", size: 25.8 },
      { label: "საძინებელი", size: 12.5 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 4.2 },
    ],
  },
  {
    apartmentNumber: 16,
    rooms: [
      { label: "საერთო ოთახი", size: 25.8 },
      { label: "საძინებელი", size: 12.5 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 4.2 },
    ],
  },
  {
    apartmentNumber: 17,
    rooms: [
      { label: "საერთო ოთახი", size: 24.1 },
      { label: "საძინებელი", size: 14.2 },
      { label: "სველი წერტილი", size: 6 },
      { label: "ტერასა", size: 4.2 },
    ],
  },
];

export const Projects = [
  {
    id: 1,
    name: "greenhome",
    herroImg: greenHomeOutterRenderPaths.dark,
    listImg: greenHomeOutterRenderPaths.dark,
    floorSeatchImage: GreenHomeSelectFloor,
    label: "K2 ავტომშენებელზე",
    address: "ქ.ქუთაისი ზ.ჭავჭავაძის ქუჩა N2ა",
    addressfull: "ქალაქი ქუთაისი, ზურაბ ჭავჭავაძის ქუჩა N2ა",
    status: "მიმდინარე",
    description:
      "პროექტი „k2 ავტომშენებელზე“ მისი ადგილმდებარეობიდან და დაგეგმარებიდან გამომდინარე საინტერესოა როგორც საცხოვრებლდ ასევე საინვესტიციოდ.",
    totalFloors: 10,
    totalApartments: 85,
    price: 1000,
    currecy: "usd",
    floors: [
      {
        floorNumber: 2,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: true,
          },
          {
            number: 2,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: true,
          },
          {
            number: 4,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 5,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: true,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: false,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: false,
          },
          {
            number: 8,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: false,
          },
          {
            number: 9,
            typeId: 3,
            subTypeId: "lg",
            positionId: 19,
            isSold: true,
          },

          {
            number: 10,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 12,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 13,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 14,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 15,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 16,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 3,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 17,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: true,
          },
          {
            number: 18,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 19,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: true,
          },
          {
            number: 20,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 21,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: true,
          },
          {
            number: 22,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: false,
          },
          {
            number: 23,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: true,
          },
          {
            number: 24,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: false,
          },
          {
            number: 25,
            typeId: 2,
            subTypeId: "sm3floor",
            positionId: 1,
            isSold: true,
          },
          {
            number: 26,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 27,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 28,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 29,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 30,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 31,
            typeId: 3,
            subTypeId: "xl",
            positionId: 18,
            isSold: true,
          },
          {
            number: 32,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 4,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 33,
            typeId: 1,
            subTypeId: "xs",
            positionId: 33,
            isSold: true,
          },
          {
            number: 34,
            typeId: 1,
            subTypeId: "xs",
            positionId: 34,
            isSold: true,
          },
          {
            number: 35,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 36,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: true,
          },
          {
            number: 37,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: false,
          },
          {
            number: 38,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: true,
          },
          {
            number: 39,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: true,
          },
          {
            number: 40,
            typeId: 2,
            subTypeId: "sm",
            positionId: 1,
            isSold: true,
          },

          {
            number: 41,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 42,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 43,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 44,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 45,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 46,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 47,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 48,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 5,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 49,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: true,
          },
          {
            number: 50,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 51,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: true,
          },
          {
            number: 52,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 53,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: true,
          },
          {
            number: 54,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: true,
          },
          {
            number: 55,
            typeId: 2,
            subTypeId: "xl",
            positionId: 55,
            isSold: true,
          },

          {
            number: 56,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 57,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 58,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 59,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 60,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 61,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 62,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 63,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 6,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 64,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: true,
          },
          {
            number: 65,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 66,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: true,
          },
          {
            number: 67,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 68,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: true,
          },
          {
            number: 69,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: true,
          },
          {
            number: 70,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: true,
          },
          {
            number: 71,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: true,
          },
          {
            number: 72,
            typeId: 2,
            subTypeId: "sm",
            positionId: 1,
            isSold: true,
          },

          {
            number: 73,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 74,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 75,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 76,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 77,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 78,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 79,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 80,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 7,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 81,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: true,
          },
          {
            number: 82,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 83,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: true,
          },
          {
            number: 84,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 85,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: true,
          },
          {
            number: 86,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: false,
          },
          {
            number: 87,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: true,
          },
          {
            number: 88,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: false,
          },
          {
            number: 89,
            typeId: 2,
            subTypeId: "sm",
            positionId: 1,
            isSold: true,
          },

          {
            number: 90,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 91,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 92,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 93,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 94,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 95,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 96,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 97,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 8,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 98,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: true,
          },
          {
            number: 99,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 100,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: true,
          },
          {
            number: 101,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: true,
          },
          {
            number: 102,
            typeId: 1,
            subTypeId: "md",
            positionId: 21,
            isSold: true,
          },
          {
            number: 103,
            typeId: 3,
            subTypeId: "xl",
            positionId: 20,
            isSold: true,
          },
          {
            number: 104,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: true,
          },
          {
            number: 105,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: true,
          },
          {
            number: 106,
            typeId: 2,
            subTypeId: "sm",
            positionId: 1,
            isSold: true,
          },
          {
            number: 107,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 108,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 109,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 110,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 111,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 112,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 113,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 114,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 9,
        aparmentSearchImage: FloorRenderHigh,
        apartmens: [
          {
            number: 115,
            typeId: 1,
            subTypeId: "xs",
            positionId: 15,
            isSold: false,
          },
          {
            number: 116,
            typeId: 1,
            subTypeId: "xs",
            positionId: 16,
            isSold: true,
          },
          {
            number: 117,
            typeId: 1,
            subTypeId: "xs",
            positionId: 17,
            isSold: false,
          },
          {
            number: 118,
            typeId: 1,
            subTypeId: "md",
            positionId: 6,
            isSold: false,
          },
          {
            number: 119,
            typeId: 3,
            subTypeId: "sm",
            positionId: 5,
            isSold: false,
          },
          {
            number: 120,
            typeId: 2,
            subTypeId: "2xl",
            positionId: 4,
            isSold: false,
          },
          {
            number: 121,
            typeId: 2,
            subTypeId: "xl",
            positionId: 3,
            isSold: false,
          },
          {
            number: 122,
            typeId: 3,
            subTypeId: "md",
            positionId: 2,
            isSold: true,
          },
          {
            number: 123,
            typeId: 2,
            subTypeId: "sm",
            positionId: 1,
            isSold: true,
          },
          {
            number: 124,
            typeId: 1,
            subTypeId: "xl",
            positionId: 7,
            isSold: true,
          },
          {
            number: 125,
            typeId: 1,
            subTypeId: "sm",
            positionId: 8,
            isSold: true,
          },
          {
            number: 126,
            typeId: 1,
            subTypeId: "sm",
            positionId: 9,
            isSold: true,
          },
          {
            number: 127,
            typeId: 2,
            subTypeId: "md",
            positionId: 10,
            isSold: true,
          },
          {
            number: 128,
            typeId: 1,
            subTypeId: "sm",
            positionId: 11,
            isSold: true,
          },
          {
            number: 129,
            typeId: 1,
            subTypeId: "lg",
            positionId: 12,
            isSold: true,
          },
          {
            number: 130,
            typeId: 2,
            subTypeId: "xs",
            positionId: 13,
            isSold: true,
          },
          {
            number: 131,
            typeId: 1,
            subTypeId: "xs",
            positionId: 14,
            isSold: false,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "nikea",
    herroImg: NikeaHerroImg,
    listImg: nikeaListImg,
    floorSeatchImage: NikeaHerroImg,
    label: "K2 ნიკეაზე",
    address: "ქუთაისი,ნიკეას ქუჩა N1",
    addressfull: "ქალაქი ქუთაისი, ნიკეას ქუჩა N1",
    status: "მიმდინარე",
    description:
      "K2 ნიკეაზე არის ლუქს კლასის პროექტი და ის k2 ინვესტის რიგით მეორე მასშტაბური პროექტია ქალაქ ქუთაისში. საცხოვრებელ სახლებთან ერთად მოიცავს, როგორც სავაჭრო და  კომერციულ სივრცეებს ასევე ბიზნეს ცენტრს.",
    totalFloors: 12,
    totalApartments: 85,
    price: 1100,
    currecy: "usd",
    floors: [
      {
        floorNumber: 3,
        // aparmentSearchImage: Floor3,
        aparmentSearchImage: NikeaFloorRenderImgPaths[3],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: false,
          },
          {
            number: 2,
            typeId: 3,
            subTypeId: "117.6",
            positionId: 2,
            isSold: false,
          },
          {
            number: 3,
            typeId: 2,
            subTypeId: "100.2",
            positionId: 3,
            isSold: true,
          },
          {
            number: 4,
            typeId: 2,
            subTypeId: "124.5",
            positionId: 4,
            isSold: false,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: true,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "55",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "55",
            positionId: 9,
            isSold: true,
          },
          {
            number: 10,
            typeId: 3,
            subTypeId: "112.6",
            positionId: 10,
            isSold: false,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 11,
            isSold: true,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 12,
            isSold: true,
          },
          {
            number: 13,
            typeId: 1,
            subTypeId: "50",
            positionId: 13,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 4,
        aparmentSearchImage: NikeaFloorRenderImgPaths[4],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 3,
            subTypeId: "117.6",
            positionId: 2,
            isSold: false,
          },
          {
            number: 3,
            typeId: 2,
            subTypeId: "100.2",
            positionId: 3,
            isSold: false,
          },
          {
            number: 4,
            typeId: 2,
            subTypeId: "124.5",
            positionId: 4,
            isSold: false,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: true,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "55",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "55",
            positionId: 9,
            isSold: true,
          },
          {
            number: 10,
            typeId: 3,
            subTypeId: "112.6",
            positionId: 10,
            isSold: true,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 11,
            isSold: true,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 12,
            isSold: true,
          },
          {
            number: 13,
            typeId: 1,
            subTypeId: "50",
            positionId: 13,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 5,
        aparmentSearchImage: NikeaFloorRenderImgPaths[5],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: false,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "118.1",
            positionId: 2,
            isSold: false,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "82.6",
            positionId: 3,
            isSold: false,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "141.5",
            positionId: 4,
            isSold: false,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: false,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "55",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "55",
            positionId: 9,
            isSold: true,
          },
          {
            number: 10,
            typeId: 3,
            subTypeId: "112.6",
            positionId: 10,
            isSold: true,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 11,
            isSold: true,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 12,
            isSold: true,
          },
          {
            number: 13,
            typeId: 1,
            subTypeId: "50",
            positionId: 13,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 6,
        aparmentSearchImage: NikeaFloorRenderImgPaths[6],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: true,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: false,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: false,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 3,
            subTypeId: "213.3",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 9,
            isSold: true,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 10,
            isSold: true,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "50",
            positionId: 11,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 7,
        aparmentSearchImage: NikeaFloorRenderImgPaths[7],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: true,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: true,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: true,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "52.5",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "67.9",
            positionId: 9,
            isSold: true,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 10,
            isSold: false,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 11,
            isSold: true,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "50",
            positionId: 12,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 8,
        aparmentSearchImage: NikeaFloorRenderImgPaths[8],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: true,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: true,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: true,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "52.5",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "67.9",
            positionId: 9,
            isSold: false,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 10,
            isSold: false,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 11,
            isSold: true,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "50",
            positionId: 12,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 9,
        aparmentSearchImage: NikeaFloorRenderImgPaths[9],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: true,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: true,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: false,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "52.5",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "67.9",
            positionId: 9,
            isSold: false,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 10,
            isSold: false,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 11,
            isSold: false,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "50",
            positionId: 12,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 10,
        aparmentSearchImage: NikeaFloorRenderImgPaths[10],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: true,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: false,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: false,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "52.5",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "67.9",
            positionId: 9,
            isSold: false,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 10,
            isSold: false,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 11,
            isSold: false,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "50",
            positionId: 12,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 11,
        aparmentSearchImage: NikeaFloorRenderImgPaths[11],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: false,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: false,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: true,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "52.5",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "67.9",
            positionId: 9,
            isSold: false,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 10,
            isSold: true,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 11,
            isSold: false,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "50",
            positionId: 12,
            isSold: true,
          },
        ],
      },
      {
        floorNumber: 12,
        aparmentSearchImage: NikeaFloorRenderImgPaths[12],
        apartmens: [
          {
            number: 1,
            typeId: 1,
            subTypeId: "55.3",
            positionId: 1,
            isSold: true,
          },
          {
            number: 2,
            typeId: 2,
            subTypeId: "81.4",
            positionId: 2,
            isSold: true,
          },
          {
            number: 3,
            typeId: 1,
            subTypeId: "62.7",
            positionId: 3,
            isSold: false,
          },
          {
            number: 4,
            typeId: 3,
            subTypeId: "123.8",
            positionId: 4,
            isSold: true,
          },
          {
            number: 5,
            typeId: 1,
            subTypeId: "62.1",
            positionId: 5,
            isSold: false,
          },
          {
            number: 6,
            typeId: 2,
            subTypeId: "77.5",
            positionId: 6,
            isSold: true,
          },
          {
            number: 7,
            typeId: 2,
            subTypeId: "67",
            positionId: 7,
            isSold: true,
          },
          {
            number: 8,
            typeId: 1,
            subTypeId: "52.5",
            positionId: 8,
            isSold: true,
          },
          {
            number: 9,
            typeId: 1,
            subTypeId: "67.9",
            positionId: 9,
            isSold: false,
          },
          {
            number: 10,
            typeId: 1,
            subTypeId: "49.9",
            positionId: 10,
            isSold: false,
          },
          {
            number: 11,
            typeId: 1,
            subTypeId: "49.4",
            positionId: 11,
            isSold: false,
          },
          {
            number: 12,
            typeId: 1,
            subTypeId: "50",
            positionId: 12,
            isSold: false,
          },
        ],
      },
    ],
  },
];
